import { TypedDefinition } from '@rehaje/core'

import { defaultLocales } from './constants'

import type { QueryJSCodePlugin } from './plugin'
import type { TypedSchema } from '@rehaje/core'

export class QueryJSCodeDefinition extends TypedDefinition {
  override extends: string[] = ['Query']
  override properties: TypedSchema[] = [
    {
      name: 'type',
      title: this.locales.type,
      type: 'Schema.String'
    },
    {
      name: 'id',
      title: this.locales.id,
      type: 'Schema.String'
    },
    {
      name: 'data',
      nullable: true,
      title: this.locales.data,
      type: 'Schema.Any'
    },
    {
      name: 'loading',
      title: this.locales.loading,
      type: 'Schema.Boolean'
    },
    {
      name: 'error',
      nullable: true,
      title: this.locales.error,
      type: 'Schema.Any'
    },
    {
      async: true,
      name: 'trigger',
      parameters: [
        {
          name: 'params',
          required: false,
          title: this.locales.triggerParams,
          type: 'Schema.Any'
        }
      ],
      return: { type: 'Schema.Any' },
      title: this.locales.trigger,
      type: 'Schema.Function'
    },
    {
      name: 'reset',
      return: { type: 'Schema.Void' },
      title: this.locales.reset,
      type: 'Schema.Function'
    },
    {
      name: 'props',
      properties: [
        {
          name: 'script',
          title: this.locales.propsScript,
          type: 'Schema.JavaScript'
        }
      ],
      title: this.locales.props,
      type: 'Schema.Object'
    }
  ]

  override relationTo = 'Schema.Query'

  get locales(): typeof defaultLocales {
    return (this.plugin.props.locales ??
      defaultLocales) as typeof defaultLocales
  }

  get plugin(): QueryJSCodePlugin {
    return this.getPlugin()
  }
}
